import React from 'react';
import { CornersOut } from '@piiqtechnologies/svg-icons';
import '@piiqtechnologies/ui-components';
import '../pannellum-viewer/PannellumProvider.js';
import { ViewerActionButton } from '../viewer-action/ViewerActionButton.js';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import '../../../utils/ErrorProvider.js';
import '../../../utils/LoaderProvider.js';
import '../../../utils/RefetchProvider.js';
import '../../../utils/NotificationProvider.js';
import 'tslib';
import '../../../utils/ContactProvider.js';
import '../../../utils/PolicyProvider.js';
import { useAnalytics } from '../../../utils/AnalyticsProvider.js';
import '@analytics/storage-utils';
import '../../../types/AccessDevice.js';
import '../../../types/Analytics.js';
import '../../../types/CASACommunity.js';
import '../../../types/Community.js';
import '../../../types/DxSettings.js';
import '../../../types/MagicButton.js';
import '../../../types/Pannellum.js';
import '../../../types/Prospect.js';
import '../../../types/ProspectIntelligence.js';
import '../../../types/Space.js';
import '../../../types/Tour.js';
import '../../../utils/analyticsPlugin.js';
import '../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../utils/cookieUtils.js';
import '../../../utils/termsConditionsAgreementsUtils.js';
import '../viewer-action/ViewerOutlinedActionButton.js';

const FullScreenControl = ({ fullScreenElement }) => {
    const analytics = useAnalytics();
    const webViewerElement = fullScreenElement || (document === null || document === void 0 ? void 0 : document.body);
    const toggleFullscreen = () => {
        analytics === null || analytics === void 0 ? void 0 : analytics.track("Toggle Fullscreen");
        try {
            if (document.fullscreenElement) {
                // exitFullscreen is only available on the Document object.
                (document === null || document === void 0 ? void 0 : document.exitFullscreen) && document.exitFullscreen();
                //@ts-ignore
                (document === null || document === void 0 ? void 0 : document.mozCancelFullScreen) && document.mozCancelFullScreen();
                //@ts-ignore
                (document === null || document === void 0 ? void 0 : document.webkitExitFullscreen) && document.webkitExitFullscreen();
                //@ts-ignore
                (document === null || document === void 0 ? void 0 : document.msExitFullscreen) && document.msExitFullscreen();
            }
            else {
                (webViewerElement === null || webViewerElement === void 0 ? void 0 : webViewerElement.requestFullscreen) && webViewerElement.requestFullscreen();
                //@ts-ignore
                (webViewerElement === null || webViewerElement === void 0 ? void 0 : webViewerElement.mozRequestFullScreen) && webViewerElement.mozRequestFullScreen();
                //@ts-ignore
                (webViewerElement === null || webViewerElement === void 0 ? void 0 : webViewerElement.webkitRequestFullScreen) && webViewerElement.webkitRequestFullScreen();
            }
        }
        catch (error) {
            console.error("Error toggling fullscreen", error);
        }
    };
    return (React.createElement(ViewerActionButton, { Icon: CornersOut, onClick: toggleFullscreen, "aria-label": "toggle fullscreen", label: "Full Screen" }));
};

export { FullScreenControl, FullScreenControl as default };
